// Showcase Configuration
// This file re-exports all showcase data from modular files

// Re-export types
export type {
  TranslatedText,
  TechBadge,
  KeyOutcome,
  MetricDisplay,
  ShowcaseProject,
  ShowcaseCategory,
} from './showcase-types.ts'

// Re-export icons
export { ICONS } from  './showcase-icons.ts';

// Import categories
import {
  aiSolutionsCategory,
  automationIntegrationCategory,
  webApplicationsCategory,
  consultingStrategyCategory,
} from  './projects/index.ts';

import type { ShowcaseCategory } from './showcase-types.ts'

// Showcase Categories and Projects
export const SHOWCASE_CATEGORIES: ShowcaseCategory[] = [
  aiSolutionsCategory,
  automationIntegrationCategory,
  webApplicationsCategory,
  consultingStrategyCategory,
]; 
